import * as account from "./account";
import * as tasks from "./tasks";
import * as zones from "./zones";

export const accountApi = account;
export const zonesApi = zones;
export const tasksApi = tasks;
